var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    rate,
    rateAsJSON,
    loan_type,
    featured
  } = options;

__p+='\n\n<!-- Rate Card -->\n<div class="mrtg-rate-card" data=\''+
((__t=( rateAsJSON ))==null?'':__t)+
'\'>\n   <div>\n      <div class="row gutter-sm">\n        <div class="col-xs-4 col-xxs-6">\n           ';
 if (!rate.is_editorial && rate.logo_path) {
__p+='\n              <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="link-rate-detail link-logo hidden-xs" target=\'_blank\' data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>\n               <img src="'+
((__t=( rate.logo_path ))==null?'':__t)+
'" class=\'lender-logo margin-bottom-sm display-block\'/>\n              </a>\n          ';
} else {
__p+='\n            <div class="lender margin-bottom">'+
((__t=( rate.advertiser ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n          ';
 if (rate.mls_number) {
__p+='\n           <div class="nmls">NMLS #'+
((__t=( rate.mls_number ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n          ';
 if (rate.state_license) {
__p+='\n           <div class="state-license">State Lic #'+
((__t=( rate.state_license ))==null?'':__t)+
'</div>\n          ';
}
__p+='\n          <div>'+
((__t=( rate.date_val ))==null?'':__t)+
'</div>\n          <a href="tel:'+
((__t=( rate.phone_no ))==null?'':__t)+
'" data-omtag="finance:mortgage-rate-table:phone" class="phone hidden-xxs" data-phone-number="'+
((__t=( rate.phone_no ))==null?'':__t)+
'">'+
((__t=( rate.phone_no ))==null?'':__t)+
'</a>\n          ';
 if (!rate.is_editorial) {
__p+='\n            <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="link-rate-detail hidden-xs" target=\'_blank\' data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>More details</a>\n          ';
}
__p+='\n        </div>\n        <div class="col-xs-8 col-xxs-6">\n          <div class="row">\n            <div class="col-xs-6">\n              <div class="loan">'+
((__t=( loan_type ))==null?'':__t)+
'</div>\n              <div class="rate">'+
((__t=( rate.apr_val.toFixed(3) ))==null?'':__t)+
'% <span>APR</span></div>\n              <div class="points">'+
((__t=( rate.rate.toFixed(3) ))==null?'':__t)+
'% at '+
((__t=( rate.points ))==null?'':__t)+
' point</div>\n            </div>\n            <div class="col-xs-6">\n              <div class="hidden-xxs">Monthly Payment</div>\n              <div class="monthly-payment">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.loan_payment) ))==null?'':__t)+
'<span>/mo</span></div>\n              <div class="fee">'+
((__t=( MOVE.MORTGAGE.addDollarCommas(rate.loan_fees) ))==null?'':__t)+
' fees</div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class="row gutter-sm margin-top">\n        <div class="col-xs-4 col-xxs-6">\n          ';
 if (!rate.is_editorial) {
__p+='\n            <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="link-rate-detail hidden-xxs margin-top-lg display-block" target=\'_blank\' data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>More details</a>\n          ';
}
__p+='\n          ';
 if (rate.phone_no) {
__p+='\n            <a href="tel:'+
((__t=( rate.phone_no ))==null?'':__t)+
'" data-omtag="finance:mortgage-rate-table:phone" class="btn btn-default btn-phone hidden-xs" data-phone-number="'+
((__t=( rate.phone_no ))==null?'':__t)+
'"><i class="ra ra-phone"></i> '+
((__t=( rate.phone_no ))==null?'':__t)+
'</a>\n          ';
}
__p+='\n        </div>\n        <div class="col-xs-8 col-xxs-6">\n          <div class="row gutter-sm">\n            <div class="col-xs-6">\n              <div class="lender-info margin-top-sm hidden-xxs">\n              </div>\n            </div>\n            <div class="col-xs-6">\n              ';
 if (!rate.is_editorial) {
__p+='\n                <a href="'+
((__t=( rate.cpc_url ))==null?'':__t)+
'" class="btn btn-primary" target=\'_blank\' data-omtag=\'finance:mortgage-rate-table:lender\' rel=\'nofollow\'>Next</a>\n              ';
}
__p+='\n            </div>\n          </div>\n        </div>\n      </div>\n   </div>\n</div>\n<!-- End Rate Card -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/rate_table_card_mobile.jst.ejs